export const GET_ADMIN_USERS_BEGIN = "GET_ADMIN_USERS_BEGIN";
export const GET_ADMIN_USERS_SUCCESS = "GET_ADMIN_USERS_SUCCESS";
export const GET_ADMIN_USERS_ERROR = "GET_ADMIN_USERS_ERROR";

export const SEND_RESET_PASSWORD_LINK_BEGIN = "SEND_RESET_PASSWORD_LINK_BEGIN";
export const SEND_RESET_PASSWORD_LINK_SUCCESS = "SEND_RESET_PASSWORD_LINK_SUCCESS";
export const SEND_RESET_PASSWORD_LINK_ERROR = "SEND_RESET_PASSWORD_LINK_ERROR";

export const DELETE_USER_BEGIN = "DELETE_USER_BEGIN";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_ERROR = "DELETE_USER_ERROR";

export const ASSIGN_REVOKE_ADMIN_RIGHTS_BEGIN = "ASSIGN_REVOKE_ADMIN_RIGHTS_BEGIN";
export const ASSIGN_REVOKE_ADMIN_RIGHTS_SUCCESS = "ASSIGN_REVOKE_ADMIN_RIGHTS_SUCCESS";
export const ASSIGN_REVOKE_ADMIN_RIGHTS_ERROR = "ASSIGN_REVOKE_ADMIN_RIGHTS_ERROR";
